import { observable } from 'mobx';

import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import { FlightsShoppingPwaFlightInformationResultsLoading } from '__generated__/api';
import JourneyStartEndDates = FlightsShoppingPwaFlightInformationResultsLoading.JourneyStartEndDates;

export class JourneyStartEndDatesStore extends Store {
  @observable public journeyStartEndDates?: JourneyStartEndDates[] | null;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}
